// 获取当前日期
export function getNowFormatDate (value) {
  let date = new Date()
  let year = date.getFullYear() // 获取完整的年份(4位)
  let month = date.getMonth() + 1 // 获取当前月份(0-11,0代表1月)
  let strDate = date.getDate() // 获取当前日(1-31)
  if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
  if (value === '-') {
    return year + '-' + month + '-' + strDate
  } else {
    return `${year}${month}${strDate}`
  }
}

/**
 * 时间格式化函数
 * @param {string | number} time
 * @param {string} fmt
 */
export const FormatTime = (time, fmt = 'YYYY/MM/DD hh:mm:ss') => {
  if (!time) return ''
  const date = new Date(time - 0)
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, date.getFullYear() + '').substr(4 - RegExp.$1.length)
  }
  const o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const key in o) {
    if (new RegExp(`(${key})`).test(fmt)) {
      const str = o[key] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}

export const weekDay = () => {
  var myDate = new Date()
  var weekend = myDate.getDay()
  var weeks = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六']
  var day = weeks[weekend]
  return day
}

export const objDateChangeStr = (objDate) => {
  var date = new Date(objDate)
  var y = date.getFullYear()
  var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return y + '-' + m + '-' + d
}

export const strDateChangeTimeTamp = (dateStr) => {
  dateStr = dateStr.replace(/-/g, '/')
  var timeTamp = new Date(dateStr).getTime()
  return timeTamp
}
/*
* @param {number} numDay 天数
* @param {string} formatDateString 需要返回时间格式
* */
export function timeLag (numDay, formatDateString) {
  var newTime = new Date()
  var oldTime = (numDay - 1) * 24 * 60 * 60 * 1000
  return [FormatTime(newTime - oldTime, formatDateString || 'YYYY-MM-DD'), FormatTime(newTime, formatDateString || 'YYYY-MM-DD')]
}
/*
* num 天数 例如：当天 1
* 根据当天时间往后推算天数
* return [2022-05-12 00:00:00， 2022-05-12 00:00:00]
* */
export function timeLagHMS (num) {
  var newTime = new Date()
  var oldTime = (num - 1) * 24 * 60 * 60 * 1000
  return [FormatTime(newTime - oldTime, 'YYYY-MM-DD hh:mm:ss'), FormatTime(newTime, 'YYYY-MM-DD hh:mm:ss')]
}

/*
* 根据两个时间计算相隔的天数
* date1 时间1  2024-01-01  格式为YYYY-MM-DD
* date2 时间2  2024-01-06 格式为YYYY-MM-DD
* return 5
* */
export function daysBetweenDates (date1, date2) {
  // 创建两个Date对象
  let d1 = new Date(date1)
  let d2 = new Date(date2)
  // 计算日期差值（以毫秒为单位）
  let diff = Math.abs(d2.getTime() - d1.getTime())
  // 将差值转换为天数
  let days = Math.floor(diff / (1000 * 60 * 60 * 24))
  return days
}

/*
* 根据传入时间往后推传入天数
* date 时间  2024-01-01  格式为YYYY-MM-DD
* daysToAdd   天数  3
* return 2024-01-04
* */
export function addDaysToDate (date, daysToAdd) {
  // 创建Date对象
  let d = new Date(date)
  // 添加天数
  d.setDate(d.getDate() + daysToAdd)
  // 返回新的日期字符串
  return d.toISOString().slice(0, 10) // toISOString() 返回 "YYYY-MM-DDTHH:mm:ss" 格式，我们只需要 "YYYY-MM-DD"
}

/**
 * 根据两个时间计算相隔的天数
 * @param {string} start 开始时间,格式2022-02-02 11:14:22
 * @param {string} end 开始时间,格式2022-02-02 16:00:00
 */
export function dateTime (start, end) {
  // 使用 try-catch 包裹以处理无效日期的情况
  try {
    const startDate = new Date(start)
    const endDate = new Date(end)

    // 检查日期有效性
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      throw new Error('Invalid date')
    }

    // 检查 start 是否晚于 end
    if (startDate > endDate) {
      throw new Error('Start date is after end date')
    }

    // 计算时间差（毫秒）
    const diff = endDate - startDate

    // 计算天、小时、分钟和秒
    const days = Math.floor(diff / (24 * 3600 * 1000))
    const hours = Math.floor((diff % (24 * 3600 * 1000)) / (3600 * 1000))
    const minutes = Math.floor((diff % (3600 * 1000)) / (60 * 1000))
    const seconds = Math.round((diff % (60 * 1000)) / 1000)

    // 组装返回字符串
    let returnStr = seconds + '秒'
    if (minutes > 0) {
      returnStr = minutes + '分' + returnStr
    }
    if (hours > 0) {
      returnStr = hours + '小时' + returnStr
    }
    if (days > 0) {
      returnStr = days + '天' + returnStr
    }

    // 返回对象，移除初始化时赋予的空字符串
    return {
      day: days,
      hours: hours,
      seconds: seconds,
      minutes: minutes,
      returnStr: returnStr
    }
  } catch (error) {
    console.error(error.message)
    // 根据函数的错误处理策略，这里可以选择抛出错误，或者返回一个特定的错误对象/值
    throw error // 或者是 return { error: 'Error calculating date difference' };
  }
}



// WEBPACK FOOTER //
// ./src/utils/timer.js